import { styled } from '@mui/material';
import { FormLabel as MuiFormLabel } from '@mui/material';

function FormLabel(props: { label: string }) {
    return <StyledFormLabel>{props.label}</StyledFormLabel>;
}

export { FormLabel };

const StyledFormLabel = styled(MuiFormLabel)(({ theme }) => ({ marginRight: theme.spacing(2) }));
